module.exports = __webpack_public_path__ + "templates.product-set-selector-1b9bca41.html";